import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import { FETCH_MANAGEMENT_TAGS_ASYNC } from '../constants'

import {
  fetchAllTagsError,
  fetchAllTagsSuccess,
  fetchDepartmentsError,
  fetchDepartmentsSuccess,
  fetchTitlesError,
  fetchTitlesSuccess,
} from './actions'
import { FETCH_ALL_TAGS_ASYNC, FETCH_DEPARTMENTS_ASYNC, FETCH_TITLES_ASYNC } from './constants'

const fetchAllTagsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS, FETCH_ALL_TAGS_ASYNC.INITIATE),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return window.location.href.indexOf(URL_CONST.mailboxes.management) !== -1
      return true
    }),
    mergeMap(() =>
      api.mailboxes
        .getTags({
          companyId: state$.value.partnerOptions.selectedCompany?.value,
          allTags: false,
          page: state$.value.mailboxes.addMailbox.allTags.page,
          search: state$.value.mailboxes.addMailbox.allTags.search,
          source: 'reduced',
        })
        .pipe(
          map((response) => fetchAllTagsSuccess(response)),
          catchError((error) => of(epicsErrorHandler(fetchAllTagsError, error))),
          takeUntil(action$.pipe(ofType(FETCH_MANAGEMENT_TAGS_ASYNC.CANCEL)))
        )
    )
  )

const fetchTitlesEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS, FETCH_TITLES_ASYNC.INITIATE),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return window.location.href.indexOf(URL_CONST.mailboxes.management) !== -1
      return true
    }),
    mergeMap(() =>
      api.mailboxes
        .getTags({
          companyId: state$.value.partnerOptions.selectedCompany?.value,
          allTags: false,
          page: state$.value.mailboxes.addMailbox.titles.page,
          search: state$.value.mailboxes.addMailbox.titles.search,
          source: 'title',
        })
        .pipe(
          map((response) => fetchTitlesSuccess(response)),
          catchError((error) => of(epicsErrorHandler(fetchTitlesError, error))),
          takeUntil(action$.pipe(ofType(FETCH_TITLES_ASYNC.CANCEL)))
        )
    )
  )

const fetchDepartmentsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS, FETCH_DEPARTMENTS_ASYNC.INITIATE),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return window.location.href.indexOf(URL_CONST.mailboxes.management) !== -1
      return true
    }),
    mergeMap(() =>
      api.mailboxes
        .getTags({
          companyId: state$.value.partnerOptions.selectedCompany?.value,
          allTags: false,
          page: state$.value.mailboxes.addMailbox.departments.page,
          search: state$.value.mailboxes.addMailbox.departments.search,
          source: 'department',
        })
        .pipe(
          map((response) => fetchDepartmentsSuccess(response)),
          catchError((error) => of(epicsErrorHandler(fetchDepartmentsError, error))),
          takeUntil(action$.pipe(ofType(FETCH_DEPARTMENTS_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(fetchAllTagsEpic, fetchDepartmentsEpic, fetchTitlesEpic)
